export const GET_CUSTOMER_TOKENIZATION_PAGE_START =
  'GET_CUSTOMER_TOKENIZATION_PAGE_START';
export const GET_CUSTOMER_TOKENIZATION_PAGE_SUCCESS =
  'GET_CUSTOMER_TOKENIZATION_PAGE_SUCCESS';
export const GET_CUSTOMER_TOKENIZATION_PAGE_FAIL = 'GET_CUSTOMER_TOKENIZATION_PAGE_FAIL';

export const CREATE_UPDATE_CUSTOMER_START = 'CREATE_UPDATE_CUSTOMER_START';
export const CREATE_UPDATE_CUSTOMER_SUCCESS = 'CREATE_UPDATE_CUSTOMER_SUCCESS';
export const CREATE_UPDATE_CUSTOMER_FAIL = 'CREATE_UPDATE_CUSTOMER_FAIL';

export const SET_CUSTOMER_FORM_FIELD_REQUIRED_MAPPING =
  'SET_CUSTOMER_FORM_FIELD_REQUIRED_MAPPING';
export const CLEAR_CUSTOMER_FORM_STATE = 'CLEAR_CUSTOMER_FORM_STATE';
export const SET_CUSTOMER_REQUIRED_FIELDS = 'SET_CUSTOMER_REQUIRED_FIELDS';
export const CLEAR_CUSTOMER_REQUIRED_FIELDS = 'CLEAR_CUSTOMER_REQUIRED_FIELDS';
export const SET_PARSED_CUSTOMER_FIELDS = 'SET_PARSED_CUSTOMER_FIELDS';

export const GET_CUSTOMER_PAYMENT_METHODS_START = 'GET_CUSTOMER_PAYMENT_METHODS_START';
export const GET_CUSTOMER_PAYMENT_METHODS_SUCCESS =
  'GET_CUSTOMER_PAYMENT_METHODS_SUCCESS';
export const GET_CUSTOMER_PAYMENT_METHODS_FAIL = 'GET_CUSTOMER_PAYMENT_METHODS_FAIL';

export const SET_DEFAULT_CARD_START = 'SET_DEFAULT_CARD_START';
export const SET_DEFAULT_CARD_SUCCESS = 'SET_DEFAULT_CARD_SUCCESS';
export const SET_DEFAULT_CARD_FAIL = 'SET_DEFAULT_CARD_FAIL';
export const SET_DEFAULT_CARD_END = 'SET_DEFAULT_CARD_END';

export const EDIT_CARD_START = 'EDIT_CARD_START';
export const EDIT_CARD_SUCCESS = 'EDIT_CARD_SUCCESS';
export const EDIT_CARD_FAIL = 'EDIT_CARD_FAIL';

export const DELETE_CARD_START = 'DELETE_CARD_START';
export const DELETE_CARD_SUCCESS = 'DELETE_CARD_SUCCESS';
export const DELETE_CARD_FAIL = 'DELETE_CARD_FAIL';

export const SET_EDIT_CARD_EXPANDED = 'SET_EDIT_CARD_EXPANDED';
